import { render, staticRenderFns } from "./QuestionInput.vue?vue&type=template&id=11812726&"
import script from "./QuestionInput.vue?vue&type=script&lang=js&"
export * from "./QuestionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports